var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-poster-container"},[_c('img',{staticClass:"site-access-poster",attrs:{"src":require("../assets/common/site-access-poster.svg"),"alt":"Site Access Poster"}}),_c('img',{staticClass:"standard-logo",attrs:{"src":require("../assets/common/standard-logo.svg"),"alt":"Standard Logo"}})])
}]

export { render, staticRenderFns }